import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectsBulkFolderAssignmentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bulkFolderAssignmentParams }) => {
      const response = await axios.post('/projects_bulk_folder_assignments', {
        bulk_folder_assignment: bulkFolderAssignmentParams,
      });

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries(['projectReports']);
    },
  });
}
